/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Dispatch, ReactNode, SetStateAction, useEffect } from 'react';
import Image from 'next/image';
import closeIcon from '@assets/images/close-black.svg';
import styles from './BottomDrawer.module.css';

type Props = {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  isTopOffset?: boolean;
  showCloseButton?: boolean;
};

export default function BottomDrawer({
  setIsOpen = () => null,
  isTopOffset = false,
  showCloseButton = false,
  children,
  isOpen,
}: Props) {
  const closeDrawer = () => {
    if (setIsOpen) setIsOpen(false);
  };

  // Add/remove the 'no-scroll' class to the body when the drawer is open/closed
  useEffect(() => {
    const handleBodyScroll = () => {
      document.body.classList.add('no-scroll');
    };

    const handleBodyScrollCleanup = () => {
      document.body.classList.remove('no-scroll');
    };

    if (isOpen) {
      handleBodyScroll();
    } else {
      handleBodyScrollCleanup();
    }

    return () => {
      handleBodyScrollCleanup();
    };
  }, [isOpen]);

  return (
    <>
      <div
        className={`${
          isOpen ? 'block' : 'hidden'
        } fixed left-0 top-0 h-full w-full z-100 bg-rp-black-faded overflow-auto`}
        onClick={closeDrawer}
        onKeyDown={() => closeDrawer}
        role="button"
        tabIndex={0}
      />
      <div
        className={`${
          isOpen ? (isTopOffset ? styles.openOffset : styles.open) : styles.close
        } drawer fixed bg-white left-0 w-full rounded-t-xl flex flex-col justify-center overflow-auto overflow-x-hidden`}
      >
        {showCloseButton ? (
          <div className="relative pt-20">
            <div className="absolute top-10 left-5">
              <button type="button" onClick={closeDrawer}>
                <Image src={closeIcon} width={15} height={15} alt="Close" />
              </button>
            </div>
            {children}
          </div>
        ) : (
          children
        )}
      </div>
    </>
  );
}
